import { render, staticRenderFns } from "./ListPanelChannelItem.vue?vue&type=template&id=096acfab&scoped=true&"
import script from "./ListPanelChannelItem.vue?vue&type=script&lang=js&"
export * from "./ListPanelChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./ListPanelChannelItem.vue?vue&type=style&index=0&id=096acfab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096acfab",
  null
  
)

export default component.exports